import { motion } from "framer-motion";
import { Server, Brain, Database, Layout, ArrowDown } from "lucide-react";

const layers = [
  { icon: Layout, name: "Application Layer", desc: "Enterprise Apps, Voice AI, IoT Dashboards, Analytics Interfaces", color: "#c9a84c" },
  { icon: Brain, name: "AI & ML Engine", desc: "LLM Orchestration, Fine-tuned Models, Agentic Workflows, Governance Layer", color: "#8b5cf6" },
  { icon: Database, name: "Data Privacy Layer", desc: "Encrypted Pipelines, Consent Management, Audit Trails, Zero Data Leakage", color: "#3b82f6" },
  { icon: Server, name: "Secure Deployment", desc: "Client-controlled On-prem, VPC, or Sovereign Cloud — deployed within your environment", color: "#10b981" },
];

export const ArchitectureSection = () => (
  <section id="architecture" data-testid="architecture-section" className="py-24 md:py-32 section-alt relative">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <p className="text-[#c9a84c] font-heading font-semibold text-sm tracking-widest uppercase mb-4">
          Technical Architecture
        </p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground tracking-tight">
          The Private AI <span className="text-gradient-gold">Stack</span>
        </h2>
        <p className="font-body text-muted-foreground mt-4 max-w-2xl mx-auto">
          A sovereign, layered architecture designed for enterprise-grade security and performance.
        </p>
      </motion.div>

      <div className="max-w-3xl mx-auto space-y-4">
        {layers.map((layer, i) => (
          <motion.div
            key={layer.name}
            initial={{ opacity: 0, x: i % 2 === 0 ? -30 : 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.15 }}
          >
            <div
              className="glass-card rounded-lg p-6 flex items-center gap-6 group"
              style={{ borderLeftWidth: "3px", borderLeftColor: layer.color }}
              data-testid={`arch-layer-${i}`}
            >
              <div
                className="w-14 h-14 rounded-lg flex items-center justify-center shrink-0"
                style={{ backgroundColor: `${layer.color}15` }}
              >
                <layer.icon className="h-7 w-7" style={{ color: layer.color }} />
              </div>
              <div>
                <h3 className="font-heading font-semibold text-foreground text-lg">{layer.name}</h3>
                <p className="font-body text-muted-foreground text-sm mt-1">{layer.desc}</p>
              </div>
            </div>
            {i < layers.length - 1 && (
              <div className="flex justify-center py-2">
                <ArrowDown className="h-4 w-4 text-[#c9a84c]/40" />
              </div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
